
import { defineComponent, ref } from "vue";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useToast } from "vue-toastification";
import ApiService from "@/core/services/ApiService";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "add-customer-modal",
  components: {},
  setup() {
    const formRef = ref<null | HTMLFormElement>(null);
    const addCustomPriceRef = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);
    const formData = ref({
      schoolId: "",
      title: "",
      item: "",
      processNumber: "",
      defaultPrice: "",
      tax: 0,
    });

    const rules = ref({
      title: [
        {
          required: true,
          message: "Biaya Custom Wajib Diisi",
          trigger: "change",
        },
      ],
      defaulPrice: [
        {
          required: true,
          message: "Biaya Bulanan Wajib Diisi",
          trigger: "change",
        },
      ],
      tax: [
        {
          required: true,
          message: "Biaya Registrasi Wajib Diisi",
          trigger: "change",
        },
      ],
    });

    const toast = useToast();
    const router = useRouter();
    const store = useStore();

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;

          setTimeout(() => {
            loading.value = false;

            // crmv2/main_invoice/invoice/office/invoice/setting/custom?invSettingId=
            ApiService
            .postWithData('crmv2/main_invoice/invoice/office/invoice/setting/custom?invSettingId=', formRef)
            .then((res) => {

             hideModal(addCustomPriceRef.value);

            })
            .catch((e) => {
              
              toast.error(e.response.data.tambahSekolah)

            });
            Swal.fire({
              text: "Berhasil Tambah Data",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary",
              },
            }).then(() => {
              hideModal(addCustomPriceRef.value);
            });
          }, 2000);
        } else {
          Swal.fire({
            text: "Gagal Menmabahkan Data",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return false;
        }
      });
    };

    return {
      formData,
      rules,
      submit,
      formRef,
      loading,
      addCustomPriceRef,
    };
  },
});
